import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { EnvConfig } from '../envConfig';

export class Graphback {
  private static accessToken: string | null = null;
  private static shareToken: string | null = null;
  private static instance: AxiosInstance | null = null;

  public static initialize(accessToken: string): void {
    this.accessToken = accessToken;
    this.getOrCreateInstance();
  }

  public static dispose(): void {
    this.accessToken = null;
  }

  public static setShareToken(shareToken: string | null): void {
    this.shareToken = shareToken;
  }

  public static getInstance(): AxiosInstance {
    return this.getOrCreateInstance();
  }

  private static getOrCreateInstance(): AxiosInstance {
    if (this.instance) return this.instance;

    const instance = axios.create({
      baseURL: EnvConfig.graphqlUrl,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    instance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        if (Graphback.accessToken) {
          config.headers.set('Authorization', `Bearer ${Graphback.accessToken}`);
        } else {
          config.headers.delete('Authorization');
        }
        if (Graphback.shareToken) {
          config.headers.set('x-gripp-share-token', Graphback.shareToken);
        } else {
          config.headers.delete('x-gripp-share-token');
        }
        return config;
      }
    );

    this.instance = instance;
    return instance;
  }
}
